import { EventBus } from "../event-bus";

export default {
  data() {
    return {
      eventBusForMasterHandler: null
    };
  },

  methods: {
    registerEventBusForMaster(handler) {
      EventBus.$on(
        this._getToRouteName(this.$route.name) || this.$route.name, //trong TH refresh tại trang detail > phải lấy theo tên của trang detai;
        (this.eventBusForMasterHandler = handler)
      );
    },

    unregisterEventBusForMaster() {
      EventBus.$off(this.$route.name, this.eventBusForMasterHandler);
    },

    notifyMasterForDataChange(event) {
      let masterRouteName = this._getToRouteName(this.$route.name);
      EventBus.$emit(masterRouteName, event);
    },

    goBack() {
      this._handleGoBack(this.$route.name);
    },

    _handleGoBack(fromRouteName) {
      switch (fromRouteName) {
        default:
          let toRouteName = this._getToRouteName(fromRouteName);
          !toRouteName
            ? this.$router.back()
            : this.$router.replace({
              name: toRouteName,
              params: this._handleGoBackParams(fromRouteName, toRouteName),
              query: this._handleGoBackQuery(fromRouteName, toRouteName)
            });
      }
    },

    _getToRouteName(fromRouteName) {
      switch (fromRouteName) {
        case "vbDenDaXuLyDetail":
          return "vbDenDaXuLy";
        case "detail-job":
        case "job-index":
          return "job-index";
        case "notifiDetail":
        case "notifi":
          return "notifi";
        case "office-user-detail":
        case "office-user":
          return "office-user";
        case "discussionDetail":
        case "discussion":
          return "discussion";
        case "myNotifiDetail":
          return "myNotifi";
        case "detail-job-coordinate":
        case "job-index-coordinate":
          return "job-index-coordinate";
        case "job-index-dept-assigned":
        case "detail-job-dept-assigned":
          return "job-index-dept-assigned";
        case "detail-job-assigned":
        case "job-index-assigned":
          return "job-index-assigned";
        case "QuanTriNguoiDungDetail":
          return "quanTriNguoiDung";
        case "DocumentDetail":
          return "document";
        case "QuanTriDonViDetail":
          return "QuanTriDonVi";
        case "quanlySoDiDetail":
          return "quanlySoDi";
        case "quanlySoDenDetail":
          return "quanlySoDen";
        case "vbChoBanHanhDetail":
          return "vbChoBanHanh";
        case "adminstration-concludeDetail":
          return "adminstration-conclude";
        case "adminstration-getCarDetail":
          return "adminstration-getCar";
        case "adminstration-bookflight-detail":
          return "adminstration-bookflight";
        case "adminstration-bookHotel-detail":
          return "adminstration-bookHotel";
        case "adminstration-suaChuaNho-detail":
          return "adminstration-suaChuaNho";
        case "adminstration-detail":
          return "adminstration-index";
        default:
          return null;
      }
    },

    _handleGoBackParams(fromRouteName, toRouteName) {
      return this.$route.params;
    },

    _handleGoBackQuery(fromRouteName, toRouteName) {
      return this.$route.query;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/goBackMixin.js